import GetStartedCard from './GetStartedCard';
import './GetStarted.scss';

const TransactionsGetStarted = () => {
    return (
        <>
            <div className="get-started-row">
                <GetStartedCard
                    title="Quick Start"
                    description="Get started quickly by using our suggested transaction templates. We have a variety of common transactions to choose from."
                    btnLink="/transaction-suggestions"
                    btnClass="button button-slim button-blue"
                    btnText="Suggested Transactions"
                    flagText="Recommended"
                />

                <GetStartedCard
                    title="From Scratch"
                    description="Create your own transaction from scratch. No pre-populated fields."
                    btnClass={"button button-slim button-green"}
                    btnLink={"/add-transaction"}
                    btnText={"Create Your Own"}
                />
            </div>
        </>
    )
}

export default TransactionsGetStarted